import React from 'react'
import ProductCard from './ProductCard'
import { Row } from 'react-bootstrap'



const ProductList = ({data}) => {
    return (
        <Row>
            {data?.map((item,index)=>{
                return(
                    <ProductCard key={index} item={item} />
                )
            })}
        </Row>
    )
}

export default ProductList